import React from 'react'

import { ButtonGroupWrap } from '../../generic/buttonGroup'
import SelectColor from '../../generic/selectColor'
import Error from '../../generic/Error'
export default ({ colors, color, updateVehicleProp, isIneligible, isError }) => (
  <>
    <ButtonGroupWrap>
      <SelectColor colors={colors} color={color} onClick={colorName => updateVehicleProp('color', colorName)} />
    </ButtonGroupWrap>
    {!isIneligible && <Error isError={isError} id={'color-error'} testId={`vd-lb-color-error`} text={'Please select your color.'} />}
  </>
)
